import { Link, NavLink, useLocation } from "react-router-dom";
import { Wallet, Plus, ShieldCheck } from "lucide-react";
import { Logo } from "./Logo";
import { useAuth } from "@/context/AuthContext";
import { npr } from "@/lib/api";
import { NAV_ITEMS } from "./BottomNav";

export default function Header() {
  const { user } = useAuth();
  const location = useLocation();
  return (
    <header className="sticky top-0 z-40 border-b border-ts-border bg-white/95 backdrop-blur" data-testid="site-header">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-4 px-4 md:px-6">
        <Link to="/" data-testid="header-home-link" className="shrink-0"><Logo className="h-7 md:h-8" /></Link>
        <nav className="hidden items-center gap-1 md:flex">
          {NAV_ITEMS.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.to === "/"} data-testid={`desktop-nav-${n.id}`}
              className={({ isActive }) => `rounded-lg px-3.5 py-2 text-sm font-medium transition-colors duration-200 ${isActive ? "bg-ts-blue-soft text-ts-blue" : "text-ts-body hover:text-ts-heading"}`}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          {user?.role === "admin" && (
            <Link to="/admin" className="btn-outline hidden h-10 px-3 text-xs sm:inline-flex" data-testid="header-admin-link"><ShieldCheck className="h-4 w-4 text-ts-blue" /> Admin</Link>
          )}
          {user ? (
            <div className="flex items-center rounded-full border border-ts-border bg-white pl-3 shadow-card" data-testid="header-wallet-pill">
              <Link to="/profile?tab=transactions" className="flex items-center gap-2 tabular py-2 pr-2 text-sm font-semibold text-ts-heading" data-testid="header-wallet-balance">
                <Wallet className="h-4 w-4 text-ts-blue" /> {npr(user.wallet_balance)}
              </Link>
              <Link to="/wallet/top-up" state={{ returnTo: location.pathname + location.search }} className="m-1 grid h-8 w-8 place-items-center rounded-full bg-ts-blue text-white transition-colors hover:bg-ts-blue-hover" aria-label="Load wallet" data-testid="header-load-wallet-button">
                <Plus className="h-4 w-4" />
              </Link>
            </div>
          ) : user === false && (
            <>
              <Link to="/login" className="btn-outline h-10 px-4 text-sm" data-testid="header-login-button">Login</Link>
              <Link to="/register" className="btn-primary h-10 px-4 text-sm" data-testid="header-signup-button">Sign up</Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
